import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';
import CONTRATO_RESPONSABLES from '@/graphql/querys/administracion/contratos/responsables/contratoResponsables.gql';
import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';
import mixAvanceFinanciero from '@/helpers/calculos/mixAvanceFinanciero';
import mixAvanceFisico from '@/helpers/calculos/mixAvanceFisico';

export default {
  name: 'mixExcelReporteSupervision',
  mixins: [
    mixAvanceProgramado, mixAvanceFinanciero, mixAvanceFisico],
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoReportesFisicos: {
      query: CONTRATO_REPORTES_FISICOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoResponsables: {
      query: CONTRATO_RESPONSABLES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    // Retorna las privateKeys de la última foto de cada partida
    async getContratoFotos() {
      if (!this.getContratoReportesFisicos) return [];
      const partidasFotos = this.getContratoReportesFisicos
        .filter((f) => f.fecha <= this.fechaReporte)
        .map(
          (r) => r.partidas.map((p) => ({ idpartida: p.idPartida, imagenes: p.imagenes }))
            .filter((p) => p.imagenes !== null),
        ).filter((p) => p.length > 0).flat(2);

      let fotos = [];
      let noFoto = true;
      fotos.push({
        idpartida: partidasFotos[0]?.idpartida ? partidasFotos[0]?.idpartida : '',
        imagen: partidasFotos[0]?.imagenes[0] ? partidasFotos[0]?.imagenes[0] : '',
      });
      partidasFotos.forEach((f) => {
        noFoto = true;
        fotos.forEach((foto) => {
          if (foto.idpartida === f.idpartida) {
            noFoto = false;
          }
        });
        if (noFoto && f.imagenes[0]) {
          fotos
            .push({ idpartida: f.idpartida, imagen: f.imagenes[0] });
        }
      });
      if (fotos.length === 1 && fotos[0].idpartida === '') {
        fotos = [];
      }
      const publicKeys = fotos.map((f) => f.imagen).slice(0, 4);

      const BASE_URL = process.env.NODE_ENV !== 'production'
        ? 'http://localhost:3001'
        : 'https://sideop-file-server.hermosillo.gob.mx';
      const privateKeys = await this.axios({
        method: 'POST',
        url: `${BASE_URL}/files`,
        responseType: 'json',
        data: {
          publicKeys,
        },
      })
        .then((res) => res.data)
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      const ultimaFotoPartida = privateKeys
        .filter((p) => p.extension === 'jpg' || p.extension === 'jpeg')
        .map((pk) => ({ name: pk.name, extension: pk.extension }));
      return ultimaFotoPartida;
    },

  },
  computed: {
    nombreDocumento() {
      if (!this.fechaReporte) return 'REPORTE_SUPERVISIÓN';
      return `REPORTE_SUPERVISIÓN_${this.fechaReporte}`;
    },
    importeDelContrato() {
      if (!this.contrato) return 0;
      const { importe: importeModificado } = this.contrato.modificado;
      if (this.contrato.esObraFinanciada) {
        return (this.contrato.importeTotal + importeModificado);
      }
      return (this.contrato.importeTotal + importeModificado);
    },
    fechaReporte() {
      if (this.fecha === '') {
        const hoy = new Date().toLocaleDateString('en-US');
        return new Date(`${hoy} 00:00:00`).toISOString().substr(0, 10);
      }
      return new Date(`${this.fecha} 00:00:00`).toISOString().substr(0, 10);
    },
    getContratoReportesFisicos() {
      if (!this.contratoReportesFisicos) return [];
      return this.contratoReportesFisicos.slice().sort((a, b) => b.numero - a.numero);
    },

    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getHeaders() {
      const headersFiltrados = this.headers.map((headers) => headers.value);
      return headersFiltrados;
    },
    getColumnas() {
      const columnasFiltradas = this.headers.map((headers) => headers.nombreColumna);
      return columnasFiltradas;
    },
    getAvanceFinancieroGenerales() {
      return this.mixAvanceFinancieroALaFecha(this.fechaReporte).avance || 0;
    },
    getAvanceFisicoGenerales() {
      return this.mixAvanceFisicoFecha(this.fechaReporte) || 0;
    },
    getAvanceProgramadoGenerales() {
      return this.mixCalcularPrograma(this.fechaReporte).porcentaje || 0;
    },
    getFotos() {
      if (!this.getImagenesReporte()) return [];
      return this.getImagenesReporte();
    },
    getResponsable() {
      if (!this.contratoResponsables) return '';
      const responsables = this.contratoResponsables.filter((r) => r.principal === true);
      return responsables[0] ? responsables[0].funcionario.nombre : '';
    },
    // Formato, posicion y estilo a las celdas del reporte
    crearDatosDocumento() {
      const fechaReporte = this.formatoEstructura({ fecha: this.fechaReporte }).fecha_texto
        .toUpperCase();
      const avanceFisicoProgramado = `${this.getAvanceProgramadoGenerales ? this.getAvanceProgramadoGenerales : 0} %`;
      const avanceFisico = `${this.getAvanceFisicoGenerales ? this.getAvanceFisicoGenerales : 0} %`;
      return [
        {
          value: 'SECRETARÍA DE OBRAS PÚBLICAS',
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 18, bold: true,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
          },
          combinar: {
            row: 3, col: 16,
          },
        },
        {
          value: `HERMOSILLO SONORA A ${fechaReporte}`,
          row: 2,
          col: 10,
          estilo: {
            font: {
              size: 14, bold: false,
            },
            alignment: {
              horizontal: 'right', vertical: 'center',
            },
          },
          combinar: {
            row: 2, col: 16,
          },
        },
        {
          value: 'REPORTE DE SUPERVISIÓN',
          row: 5,
          col: 1,
          estilo: {
            font: {
              size: 18, bold: true,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
            fill: {
              type: 'pattern', patternType: 'solid', bgColor: '#D6D6EE', fgColor: '#D6D6EE',
            },
          },
          combinar: {
            row: 5, col: 16,
          },
        },
        {
          value: 'NO. CONTRATO:',
          row: 13,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: true,
            },
          },
          combinar: {
            row: 13, col: 2,
          },
        },
        {
          value: this.contrato.numero,
          row: 13,
          col: 3,
          estilo: {
            font: {
              size: 12, bold: false,
            },
            alignment: {
              vertical: 'center', wrapText: true,
            },
          },
          combinar: {
            row: 13, col: 15,
          },
        },
        {
          value: 'OBRA:',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: true,
            },
          },
          combinar: {
            row: 7, col: 2,
          },
        },
        {
          value: this.contrato.meta,
          row: 7,
          col: 3,
          estilo: {
            font: {
              size: 12, bold: false,
            },
            alignment: {
              vertical: 'center', wrapText: true,
            },
          },
          combinar: {
            row: 12, col: 16,
          },
        },
        {
          value: 'CONTRATISTA:',
          row: 14,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: true,
            },
          },
          combinar: {
            row: 14, col: 2,
          },
        },
        {
          value: this.contrato.contratista.nombreRazonSocial,
          row: 14,
          col: 3,
          estilo: {
            font: {
              size: 12, bold: false,
            },
          },
          combinar: {
            row: 14, col: 15,
          },
        },
        {
          value: 'MONTO CONTATADO:',
          row: 15,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: true,
            },
          },
          combinar: {
            row: 15, col: 2,
          },
        },
        {
          value: this.contrato.importe,
          row: 15,
          col: 3,
          estilo: {
            font: {
              size: 12, bold: true,
            },
            alignment: {
              vertical: 'center', horizontal: 'left',
            },
            numberFormat: '$#,##0.00',
          },
          combinar: {
            row: 15,
            col: 15,
          },
        },
        {
          value: 'RESUMEN GLOBAL DEL AVANCE',
          row: 17,
          col: 1,
          estilo: {
            font: {
              size: 14, bold: true,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
            fill: {
              type: 'pattern', patternType: 'solid', bgColor: '#F2F6FF', fgColor: '#F2F6FF',
            },
          },
          combinar: {
            row: 17, col: 16,
          },
        },
        {
          value: 'AVANCE FÍSICO PROGRAMADO:',
          row: 18,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: true,
            },
          },
          combinar: {
            row: 18, col: 2,
          },
        },
        {
          value: avanceFisicoProgramado,
          row: 18,
          col: 3,
          estilo: {
            font: {
              size: 12, bold: true,
            },
            alignment: {
              vertical: 'center', horizontal: 'left',
            },
            numberFormat: '0.00%',
          },
          combinar: {
            row: 18, col: 15,
          },
        },
        {
          value: 'AVANCE FÍSICO REAL:',
          row: 19,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: true,
            },
          },
          combinar: {
            row: 19, col: 2,
          },
        },
        {
          value: avanceFisico,
          row: 19,
          col: 3,
          estilo: {
            font: {
              size: 12, bold: true,
            },
            alignment: {
              vertical: 'center', horizontal: 'left',
            },
            numberFormat: '0.00%',
          },
          combinar: {
            row: 19, col: 15,
          },
        },
        {
          value: 'TRABAJOS REALIZADOS',
          row: 20,
          col: 1,
          estilo: {
            font: {
              size: 14, bold: true,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
            fill: {
              type: 'pattern', patternType: 'solid', bgColor: '#F2F6FF', fgColor: '#F2F6FF',
            },
          },
          combinar: {
            row: 20, col: 16,
          },
        },
        {
          value: '-',
          row: 21,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: false,
            },
            alignment: {
              horizontal: 'left', vertical: 'center',
            },
          },
          combinar: {
            row: 21, col: 16,
          },
        },
        {
          value: 'DEFICIENCIAS Y/0 COMENTARIOS',
          row: 22,
          col: 1,
          estilo: {
            font: {
              size: 14, bold: true,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
            fill: {
              type: 'pattern', patternType: 'solid', bgColor: '#F2F6FF', fgColor: '#F2F6FF',
            },
          },
          combinar: {
            row: 22, col: 16,
          },
        },
        {
          value: '-',
          row: 23,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: false,
            },
            alignment: {
              horizontal: 'left', vertical: 'center',
            },
          },
          combinar: {
            row: 23, col: 16,
          },
        },
        {
          value: 'FOTOGRAFÍAS',
          row: 24,
          col: 1,
          estilo: {
            font: {
              size: 14, bold: true,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
            fill: {
              type: 'pattern', patternType: 'solid', bgColor: '#F2F6FF', fgColor: '#F2F6FF',
            },
          },
          combinar: {
            row: 24, col: 16,
          },
        },
        {
          value: 'FIRMA DEL RESIDENTE RESPONSABLE',
          row: this.filaTerminaFotografias,
          col: 1,
          estilo: {
            font: {
              size: 14, bold: true,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
            fill: {
              type: 'pattern', patternType: 'solid', bgColor: '#F2F6FF', fgColor: '#F2F6FF',
            },
          },
          combinar: {
            row: this.filaTerminaFotografias, col: 16,
          },
        },
        {
          value: this.getResponsable,
          row: this.filaTerminaFotografias + 3,
          col: 1,
          estilo: {
            font: {
              size: 12, bold: false,
            },
            alignment: {
              horizontal: 'center', vertical: 'center',
            },
          },
          combinar: {
            row: this.filaTerminaFotografias + 3, col: 16,
          },
        },
      ];
    },
  },
};
